export const QA_NAME_TASK_STATUS_TOGGLE = 'status'
